import { initParallax } from "./parallax";

window.addEventListener("carousel-ready", () => {

  document.querySelectorAll('.carousel-elastic_hero').forEach((container) => {

    if (container.classList.contains('parallax-initialized')) {
      return; // already initialized
    }
    
    container.classList.add('parallax-initialized');

    initParallax({
      container: container as HTMLElement,
      selector: ".carousel-card__hero",
      speeds: [0.05, 0.1, 0.15, 0.2], // optional, or omit for automatic variation
    });

  });


  
});